var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "404-page page-error" },
    [
      _c("EmptyState", {
        attrs: {
          "confirm-action": _vm.redirect,
          illustration: "403-Version2",
          title:
            "Ops! Parece que você não tem permissão para acessar esta página",
          subtitle:
            "Contate a pessoa que administra sua conta para obter maiores detalhes. Enquanto isso, você pode continuar navegando e voltar para o início.",
          "confirm-action-text": "Voltar para o início",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }